import { Microfrontend } from '@cian/mf-react';
import * as React from 'react';

import { useChatbotFilters } from './useChatbotFilters';
import { ErrorContent, LoadingContent } from '../../components/ChatbotFilters';
import { EManifestStatus } from '../../types/chatbotFiltersModal';

import type { ICianMFUIElement } from '@cian/mf-registry/browser';

interface IChatbotFiltersContainerProps {
  microfrontendRef: React.RefObject<ICianMFUIElement>;
}
export const ChatbotFiltersContainer: React.FC<IChatbotFiltersContainerProps> = ({ microfrontendRef }) => {
  const { manifestStatus, manifest, fetchManifest } = useChatbotFilters();

  if (manifestStatus === EManifestStatus.Loading || manifestStatus === EManifestStatus.Initial) {
    return <LoadingContent />;
  }

  if (!manifest) {
    return <ErrorContent onRetry={fetchManifest} />;
  }

  return <Microfrontend ref={microfrontendRef} {...manifest} />;
};
